<template>
  <div
    class="money-in-cn"
    :title="moneyInCn"
    :class="{ 'text-ellipsis': ellipsis }"
  >
    <span v-if="money">
      <span v-if="showPrefix">{{ prefixLabel }}：</span>
      {{ moneyInCn }}
    </span>
  </div>
</template>

<script>
import nzhcn from 'nzh/cn'
import { getMoneyInCn } from '@/utils/utils'

export default {
  name: 'MoneyInCn',

  props: {
    // 金额
    money: {
      type: [Number, String],
      default: 0
    },

    // 是否显示大写前缀
    showPrefix: {
      type: Boolean,
      default: true
    },

    prefixLabel: {
      type: String,
      default: '大写'
    },

    // 内容宽度
    width: {
      type: String,
      default: '100%'
    },

    // 是否使用溢出省略
    ellipsis: {
      type: Boolean,
      default: false
    },

    // 金额倍数
    multiple: {
      type: Number,
      default: 1
    }
  },

  computed: {
    moneyInCn() {
      return getMoneyInCn(this.money, this.multiple)
    }
  }
}
</script>

<style lang="scss" scoped>
.money-in-cn {
  // width: 100%;
  color: $danger-color;
  font-size: 12px;
  line-height: 1.6;
  //text-align: left;
}
</style>
